import { ModelSagres } from "../model-sagres"

export class PrazoDeVencimento extends ModelSagres {
    Referencia: number
    PeriodoPrestacao: string
    IdEsfera: number
    DataVencimentoOriginal: Date
    DataVencimento: Date
    Exercicio: number
    IdVencimentoSagres?: number
    Justificativa: string

    /**
     * Trata os dados recebidos pela API. Estão vindo com estas três inconsistências no momento. Não execute em outras situações
     * @since 20220613
     */
    tratarDadosDaAPI(): void {
        if (typeof (this as any).Ref !== 'undefined') {
            this.Referencia = (this as any).Ref
        }
        if (this.DataVencimento) {
            this.DataVencimento = new Date(this.DataVencimento)
        }
        if (this.DataVencimentoOriginal) {
            this.DataVencimentoOriginal = new Date(this.DataVencimentoOriginal)
        }
    }
}